import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import './plugins/dialog';
import router from './router'
import './plugins/axios';
import './plugins/auth';
import i18n from './i18n'
import confirmLeaveDialog from "./plugins/confirmLeaveDialog";
import functions from "./plugins/functions";
import VueCountryCode from "vue-country-code-select";

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');

Vue.use(confirmLeaveDialog);
Vue.use(functions);
Vue.use(VueCountryCode);

/**
 * Function which can match strings partially against a reg ex.
 * Copied from TDB code resources/js/main.js::148 commit: 66927db77a6de409ba415be3db37a1cd02c901f6
 * Which was copied from stack overflow (Lucas Trzesniewski 10.01.2017)
 * https://stackoverflow.com/questions/22483214/regex-check-if-input-still-has-chances-to-become-matching/41580048#41580048
 * @returns {RegExp}
 */
RegExp.prototype.toPartialMatchRegex = function() {
  "use strict";

  let re = this,
      source = this.source,
      i = 0;

  function process() {
    let result = "",
        tmp;

    function appendRaw(nbChars) {
      result += source.substring(i, nbChars + i);
      i += nbChars;
    }

    function appendOptional(nbChars) {
      result += "(?:" + source.substring(i, nbChars + i) + "|$)";
      i += nbChars;
    }

    while (i < source.length) {
      switch (source[i]) {
        case "\\":
          switch (source[i + 1]) {
            case "c":
              appendOptional(3);
              break;

            case "x":
              appendOptional(4);
              break;

            case "u":
              if (re.unicode) {
                if (source[i + 2] === "{") {
                  appendOptional(
                      source.indexOf("}", i) - i + 1
                  );
                } else {
                  appendOptional(6);
                }
              } else {
                appendOptional(2);
              }
              break;

            case "p":
            case "P":
              if (re.unicode) {
                appendOptional(source.indexOf("}", i) - i + 1);
              } else {
                appendOptional(2);
              }
              break;

            case "k":
              appendOptional(source.indexOf(">", i) - i + 1);
              break;

            default:
              appendOptional(2);
              break;
          }
          break;

        case "[":
          tmp = /\[(?:\\.|.)*?\]/g;
          tmp.lastIndex = i;
          tmp = tmp.exec(source);
          appendOptional(tmp[0].length);
          break;

        case "|":
        case "^":
        case "$":
        case "*":
        case "+":
        case "?":
          appendRaw(1);
          break;

        case "{":
          tmp = /\{\d+,?\d*\}/g;
          tmp.lastIndex = i;
          tmp = tmp.exec(source);
          if (tmp) {
            appendRaw(tmp[0].length);
          } else {
            appendOptional(1);
          }
          break;

        case "(":
          if (source[i + 1] == "?") {
            switch (source[i + 2]) {
              case ":":
                result += "(?:";
                i += 3;
                result += process() + "|$)";
                break;

              case "=":
                result += "(?=";
                i += 3;
                result += process() + ")";
                break;

              case "!":
                tmp = i;
                i += 3;
                process();
                result += source.substring(tmp, i);
                break;

              case "<":
                switch (source[i + 3]) {
                  case "=":
                  case "!":
                    tmp = i;
                    i += 4;
                    process();
                    result += source.substring(
                        tmp,
                        i
                    );
                    break;

                  default:
                    appendRaw(
                        source.indexOf(">", i) - i + 1
                    );
                    result += process() + "|$)";
                    break;
                }
                break;
            }
          } else {
            appendRaw(1);
            result += process() + "|$)";
          }
          break;

        case ")":
          ++i;
          return result;

        default:
          appendOptional(1);
          break;
      }
    }

    return result;
  }

  return new RegExp(process(), this.flags);
};
